import React, { useState, useEffect } from "react";
import useLastViewsHook from '~/utils/last-views'

import TilePage from '~/components/tile/tile-page'

import * as styles from "~/styles/pdp/cross_sell.module.scss"

const LastViewed = ({ product_id }) => {
  const { getLasts } = useLastViewsHook()
  const [products, setProducts] = useState(false)

  useEffect(() => {
    const check_lasts = getLasts({product_id: product_id})
    setProducts(check_lasts)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.tiles}>
      {products && products.map( (prod, index) =>
        <TilePage 
          key={prod.handle} 
          product={prod} 
          tile_ind={index} 
          page_type={'last viewed products'} 
        />
      )}
    </div>
  )
}

export default LastViewed



